import $api from "@/core/services/ApiService";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import { CreateWallet } from "@/core/services/api/interfaces/manager/Crypto";

class WalletEndpoint {
  public list(params: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return $api.get("manager/crypto/wallets", params);
  }

  public create(data: CreateWallet): Promise<AxiosResponse> {
    return $api.post("manager/crypto/wallets", data);
  }

  public delete(id: number): Promise<AxiosResponse> {
    return $api.delete(`manager/crypto/wallets/${id}`);
  }
}

export default WalletEndpoint;
